import React,{useState} from 'react'
import Slider from "react-slick";
import { RiStarFill } from "react-icons/ri";
import { HiArrowRight, HiArrowLeft } from "react-icons/hi";
import Title from '../layouts/Title'
import { testimonialOne,testimonialTwo, quote, testimonialthree } from "../../assets";


function SampleNextArrow(props) {
  const { onClick } = props;
  return (
    <div
      className="w-14 h-12 bg-[#0c1821] hover:bg-black duration-300 rounded-md text-2xl text-gray-400 flex justify-center items-center absolute top-0 right-0 shadow-shadowOne cursor-pointer z-10"
      onClick={onClick}
    >
      <HiArrowRight />
    </div>
  );
}

function SamplePrevArrow(props) {
  const { onClick } = props;
  return (
    <div
      className="w-14 h-12 bg-[#0c1821] hover:bg-black duration-300 rounded-md text-2xl text-gray-400 flex justify-center items-center absolute top-0 right-20 shadow-shadowOne cursor-pointer z-10"
      onClick={onClick}
    >
      <HiArrowLeft />
    </div>
  );
}

const Testimonial = () => {
      const [dotActive, setDocActive] = useState(0);
     const settings = {
       dots: true,
       infinite: true,
       speed: 500,
       slidesToShow: 1,
       slidesToScroll: 1,
       nextArrow:<SampleNextArrow />,
       prevArrow:<SamplePrevArrow />,
       beforeChange: (prev, next) => {
         setDocActive(next);
       },
       appendDots: (dots) => (
         <div
           style={{
             borderRadius: "10px",
             padding: "10px",
           }}
         >
           <ul
             style={{
               display: "flex",
               gap: "15px",
               justifyContent: "center",
               marginTop: "20px",
             }}
           >
             {" "}
             {dots}{" "}
           </ul>
         </div>
       ),
       customPaging: (i) => (
         <div
           style={
             i === dotActive
               ? {
                   width: "12px",
                   height: "12px",
                   color: "blue",
                   background: "#ff014f",
                   borderRadius: "50%",
                   cursor: "pointer",
                 }
               : {
                   width: "12px",
                   height: "12px",
                   color: "blue",
                   background: "gray",
                   borderRadius: "50%",
                   cursor: "pointer",
                 }
           }
         ></div>
       ),
     };
  return (
    <section
  id="testimonial"
  className="w-full py-20 border-b-[1px] border-b-black"
>
  <div className="flex justify-center items-center text-center">
    <Title title="WHAT CLIENTS SAY" des="Testimonial" />
  </div>
  <div className="max-w-6xl mx-auto">
    {/* ================ Slider One ================== */}
    <Slider {...settings}>
      <div className="w-full">
        <div className="w-full h-auto flex flex-col lgl:flex-row justify-between">
          <div className="w-full lgl:w-[35%] h-full bg-gradient-to-r from-[#1e2024] to-[#23272b] p-8 rounded-lg shadow-shadowOne flex flex-col md:flex-row lgl:flex-col gap-8 justify-center md:justify-start lgl:justify-center">
            <img
              className="h-72 md:h-32 lgl:h-72 rounded-lg object-cover"
              src={testimonialOne}
              alt="testimonialOne"
            />
            <div className="w-full flex flex-col justify-end">
              <p className="text-xs uppercase text-designColor tracking-wide mb-2">
                Neet Aspirant - Jai Prakash Singh
              </p>
              <h3 className="text-2xl font-bold">Jai Prakash Singh</h3>
              <p className="text-base tracking-wide text-gray-500">
              Neet Aspirant
              </p>
            </div>
          </div>
          <div className="w-full lgl:w-[60%] h-full flex flex-col justify-between">
            <img className="w-20 lgl:w-32" src={quote} alt="quote" />
            <div className="w-full h-[70%] py-10 bg-gradient-to-r from-[#1e2024] to-[#23272b] rounded-lg shadow-shadowOne p-4 lgl:p-8 flex flex-col justify-center gap-4 lgl:gap-8">
              <div className="flex flex-col justify-between lgl:items-center py-6 border-b-2 border-b-gray-900">
                <div>
                  <h3 className="text-xl lgl:text-2xl font-medium tracking-wide">
                    Counselling Website Development
                  </h3>
                  <p className="text-base text-gray-400 mt-3">
                    via LinkedIn - Nov 2024 to Dec 2024
                  </p>
                </div>
                <div className="text-yellow-500 flex gap-1">
                  <RiStarFill />
                  <RiStarFill />
                  <RiStarFill />
                  <RiStarFill />
                  <RiStarFill />
                </div>
              </div>
              <p className="text-base font-titleFont text-gray-400 font-medium tracking-wide leading-6">
                Jai Prakash's vision for the counselling website was truly
                inspiring. The development process was seamless and his
                dedication made the project a success. He actively collaborated
                to ensure every aspect of the site was just right.
              </p>
            </div>
          </div>
        </div>
      </div>
      {/* ================ Slider Two ================== */}
      <div className="w-full">
        <div className="w-full h-auto flex flex-col lgl:flex-row justify-between">
          <div className="w-full lgl:w-[35%] h-full bg-gradient-to-r from-[#1e2024] to-[#23272b] p-8 rounded-lg shadow-shadowOne flex flex-col md:flex-row lgl:flex-col gap-8 justify-center md:justify-start lgl:justify-center">
            <img
              className="h-72 md:h-32 lgl:h-72 rounded-lg object-cover"
              src={testimonialTwo}
              alt="testimonialTwo"
            />
            <div className="w-full flex flex-col justify-end">
              <p className="text-xs uppercase text-designColor tracking-wide mb-2">
                Computer House Owner - Nishant
              </p>
              <h3 className="text-2xl font-bold">Nishant</h3>
              <p className="text-base tracking-wide text-gray-500">
                Business Growth Website
              </p>
            </div>
          </div>
          <div className="w-full lgl:w-[60%] h-full flex flex-col justify-between">
            <img className="w-20 lgl:w-32" src={quote} alt="quote" />
            <div className="w-full h-[70%] py-10 bg-gradient-to-r from-[#1e2024] to-[#23272b] rounded-lg shadow-shadowOne p-4 lgl:p-8 flex flex-col justify-center gap-4 lgl:gap-8">
              <div className="flex flex-col justify-between lgl:items-center py-6 border-b-2 border-b-gray-900">
                <div>
                  <h3 className="text-xl lgl:text-2xl font-medium tracking-wide">
                    Business Growth Website Development
                  </h3>
                  <p className="text-base text-gray-400 mt-3">
                    via Word of Mouth
                  </p>
                </div>
                <div className="text-yellow-500 flex gap-1">
                  <RiStarFill />
                  <RiStarFill />
                  <RiStarFill />
                  <RiStarFill />
                  <RiStarFill />
                </div>
              </div>
              <p className="text-base font-titleFont text-gray-400 font-medium tracking-wide leading-6">
                Nishant's input was invaluable in the development of his
                business growth website. His deep understanding of the business
                needs allowed us to create a site that truly enhances his brand
                and connects with potential customers effectively.
              </p>
            </div>
          </div>
        </div>
      </div>
      {/* ================ Slider Three ================== */}
      <div className="w-full">
        <div className="w-full h-auto flex flex-col lgl:flex-row justify-between">
          <div className="w-full lgl:w-[35%] h-full bg-gradient-to-r from-[#1e2024] to-[#23272b] p-8 rounded-lg shadow-shadowOne flex flex-col md:flex-row lgl:flex-col gap-8 justify-center md:justify-start lgl:justify-center">
            <img
              className="h-72 md:h-32 lgl:h-72 rounded-lg object-cover"
              src={testimonialthree}
              alt="testimonialOne"
            />
            <div className="w-full flex flex-col justify-end">
              <p className="text-xs uppercase text-designColor tracking-wide mb-2">
                Hola9 Classified Founder - Sarang Giri
              </p>
              <h3 className="text-2xl font-bold">Sarang Giri</h3>
              <p className="text-base tracking-wide text-gray-500">
                Made4EachOther Website
              </p>
            </div>
          </div>
          <div className="w-full lgl:w-[60%] h-full flex flex-col justify-between">
            <img className="w-20 lgl:w-32" src={quote} alt="quote" />
            <div className="w-full h-[70%] py-10 bg-gradient-to-r from-[#1e2024] to-[#23272b] rounded-lg shadow-shadowOne p-4 lgl:p-8 flex flex-col justify-center gap-4 lgl:gap-8">
              <div className="flex flex-col justify-between lgl:items-center py-6 border-b-2 border-b-gray-900">
                <div>
                  <h3 className="text-xl lgl:text-2xl font-medium tracking-wide">
                    Made4EachOther Website Development
                  </h3>
                  <p className="text-base text-gray-400 mt-3">
                    via Calling
                  </p>
                </div>
                <div className="text-yellow-500 flex gap-1">
                  <RiStarFill />
                  <RiStarFill />
                  <RiStarFill />
                  <RiStarFill />
                  <RiStarFill />
                </div>
              </div>
              <p className="text-base font-titleFont text-gray-400 font-medium tracking-wide leading-6">
                Sarang Giri's vision for the Made4EachOther website was clear
                and impactful. Working together, we were able to build a site
                that truly represents his brand, making it easier for people to
                connect with the platform.
              </p>
            </div>
          </div>
        </div>
      </div>
    </Slider>
  </div>
</section>

  );
}

export default Testimonial